import documentIcon from "../../../icons/document.svg";
import homeIcon from "../../../icons/home.svg";
import bullhornIcon from "../../../icons/bullhorn.svg";
import profileIcon from "../../../icons/profile.svg";


export default [
  {
    id: 'building-item-1',
    subtitle: 'de inmuebles',
    title: 'Arrendamiento',
    icon: documentIcon,
    url: '/arrendamientos/vivienda',
    tint: 'lime',
    alt: 'Ícono de arrendamiento',
    iconTitle: 'Arrendamiento de inmuebles',
    linkTitle: 'Accede a tus servicios de arriendo de vivienda'
  },
  {
    id: 'building-item-2',
    subtitle: 'de usados',
    title: 'Compra y venta',
    icon: homeIcon,
    url: '/venta-de-usados',
    tint: 'green',
    alt: 'Ícono de precio vivienda',
    iconTitle: 'Precio de vivienda',
    linkTitle: 'Explora los inmuebles usados disponibles para la venta'
  },
  {
    id: 'building-item-3',
    subtitle: 'tus inmuebles',
    title: 'Publica',
    icon: bullhornIcon,
    url: 'https://contenidos.coninsa.co/preconsignar-inmueble/',
    tint: 'green',
    alt: 'Ícono de megafono',
    iconTitle: 'Promoción de inmuebles',
    linkTitle: 'Registra tu inmueble para iniciar el proceso de consignación'
  },
  {
    id: 'building-item-4',
    subtitle: 'Mi Coninsa Virtual',
    title: 'Portal de gestión',
    icon: profileIcon,
    url: 'https://miconinsavirtual.coninsa.co/',
    tint: 'green',
    alt: 'Ícono de formulario de acceso',
    iconTitle: 'Formulario de acceso a MCV',
    linkTitle: 'Accede a tu portal de servicios para gestionar contratos, pagos y solicitudes'
  },
]
